module.exports = __webpack_public_path__ + "img/traintaxbir.d7f4e8f1.jpg";